import { RecruiterActions } from '@src/redux/actions/recruiter/recruiter.enum';

export function customerStatus(state = null, action) {
  switch (action.type) {
    case RecruiterActions.CUSTOMER_STATUS_FETCHED: {
      const planType = action.status.planType || state.planType;

      return {
        ...state,
        ...action.status,
        planType: planType ? planType.toLowerCase() : undefined,
      };
    }

    default:
      return state;
  }
}
